<template>
    <div>

        <div v-for="(sourcePerson, index) in partner.sourcePersons" :key="index" v-if="partner.sourcePersons">
            <!-- #region بيانات الموكل -->
            <PartnerSourcePersonsComponent :sourcePerson="sourcePerson" :parentSefa="partner.partnerSefaTypeId" />
            <!-- #endregion -->
            <!-- #region بيانات الوكيل -->
            <ContractPersonComponent :showIban="false" :showContacts="false" :partner="partner" />
            <!-- #endregion -->
        </div>
    </div>
</template>
<script lang="ts">
    import { Component, Vue, Prop } from 'vue-property-decorator';

    import { ContractPartnerModel } from '@/models/contractPartnerModel';
    import { ContractDetails } from '@/models/contractDetailsModel';

    import PartnerSourcePersonsComponent from '@/components/contract/contract-partner-sourcePersons.vue';
    import ContractPersonComponent from '@/components/contract/partnerType/contract-person.component.vue';
    @Component({
        components: {
            PartnerSourcePersonsComponent,
            ContractPersonComponent
        }
    })

    export default class ContractAttorneyAgentComponent extends Vue {
        @Prop({ required: true }) partner!: ContractPartnerModel;
    }
</script>